// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"9b280934","388":"52ad3ba3","455":"e91c6951","457":"278dbe7e","551":"eebf1ec6","828":"2d949436","842":"62c3bb77","851":"05fff0bf","977":"b5448499"}[chunkId] + ".chunk.js";
};